// import ReactDOM from 'react-dom'
// import './index.css'
// import './App.css'
// import { App } from './App'
// import { ContextProvider } from './contexts/ContextProvider'

// ReactDOM.render(<ContextProvider><App/></ContextProvider>, document.getElementById('root'))
import ReactDOM from 'react-dom';
import './index.css';
import './App.css';
import { App } from './App';
import { ContextProvider } from './contexts/ContextProvider';
import { BrowserRouter } from 'react-router-dom'; // Import BrowserRouter

ReactDOM.render(
  <BrowserRouter> {/* Wrap App with BrowserRouter */}
    <ContextProvider>
      <App />
    </ContextProvider>
  </BrowserRouter>,
  document.getElementById('root')
);
